import { PaymentMethodsAddAchFormStripeProps } from '../../../components/payment-methods/add-ach/add-ach-form-stripe';
import { GatewaySwitch } from '../../../components/switches/gateway-switch';
import { usePaymentMethodsStateContext } from '../context/payment-methods-state.context';
import { usePaymentMethodsStripeContext } from '../context/payment-methods-stripe.context';

export type PaymentMethodsContextTAchFormProps = {
  stripeComponent: React.FC<PaymentMethodsAddAchFormStripeProps>;
  justifiComponent: React.FC<object>;
};
export const PaymentMethodsContextTAchForm = ({
  stripeComponent: StripeComponent,
  justifiComponent: JustifiComponent,
}: PaymentMethodsContextTAchFormProps) => {
  return (
    <GatewaySwitch
      stripeContent={StripeFormWithContext}
      stripeProps={{ render: StripeComponent }}
      justifiContent={JustifiFormWithContext}
      justifiProps={{ render: JustifiComponent }}
    />
  );
};

const StripeFormWithContext = ({
  render: StripeComponent,
}: {
  render: React.FC<PaymentMethodsAddAchFormStripeProps>;
}) => {
  const { isResendVerificationAchMode } = usePaymentMethodsStateContext();
  const { isCreatingRegistrationLink, fieldProps } = usePaymentMethodsStripeContext();
  return (
    <StripeComponent
      isResendMode={isResendVerificationAchMode}
      isLoading={isCreatingRegistrationLink}
      fieldProps={fieldProps}
    />
  );
};
const JustifiFormWithContext = () => {
  console.warn('Justifi ACH form is not supported yet');
  return <></>;
};
